import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import radium from 'radium';
import PriceLevel from './Pricelevel.jsx';

interface PriceLevelListProps {
	standardPriceLevel?: any;
	reducedPriceLevels: any[];
	ticketsAvailable: number;
	categoryUuid?: string;
}

const PriceLevelList = (props: PriceLevelListProps) => {
	const amountOfTickets = useSelector((state: any) => state.eventPage.amountOfTickets || {});
	const amountOfTicketsInCart = useSelector((state: any) => state.eventPage.amountOfTicketsInCart || {});

	//Berechnung der verfügbaren Tickets (Memoized für Performance)
	const ticketsAvailableMap = useMemo(() => {
		const priceLevelUuids = [
			props.standardPriceLevel?.priceLevelUuid,
			...props.reducedPriceLevels.map((pl: any) => pl.priceLevelUuid),
		].filter(Boolean);

		const sumNewSelected = priceLevelUuids.reduce(
			(sum, uuid) => sum + (amountOfTickets[uuid] || 0) - (amountOfTicketsInCart[uuid] || 0),
			0
		);

		const availableMap: Record<string, number> = {};
		for (const uuid of priceLevelUuids) {
			const selectedCurrent = amountOfTickets[uuid] || 0;
			availableMap[uuid] = props.ticketsAvailable + selectedCurrent - sumNewSelected;
		}
		return availableMap;
	}, [props.standardPriceLevel, props.reducedPriceLevels, props.ticketsAvailable, amountOfTickets, amountOfTicketsInCart]);

	//sort
	const priceLevels = useMemo(() => {
		const sortedReduced = [...props.reducedPriceLevels].sort((a, b) => {
			if (!a || !b || (a.pos === null && b.pos === null)) return 0;
			return (a.pos ?? 0) > (b.pos ?? 0) ? 1 : -1;
		});
		return [props.standardPriceLevel, ...sortedReduced].filter(el => el != null);
	}, [props.standardPriceLevel, props.reducedPriceLevels]);

	if (priceLevels.length === 0) return null;

	return (
		<ul>
			{priceLevels.map((priceLevel) => (
				!priceLevel.hideOnline ? (
					<li key={priceLevel.priceLevelUuid}>
						<PriceLevel
							categoryUuid={props.categoryUuid}
							pricelevel={priceLevel}
							ticketsAvailable={ticketsAvailableMap[priceLevel.priceLevelUuid]}
						/>
					</li>
				) : null
			))}
		</ul>
	);
};

export default radium(PriceLevelList);